module.exports = __webpack_public_path__ + "static/media/promo.e7a26549.png";